module.exports = __webpack_public_path__ + "static/media/T14-T25-11-01.f67fb607.svg";